export default __webpack_public_path__ + "static/media/CNo.52-1.54855e0d.jpg";